"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveActivityContentStateSchema = void 0;
var zod_1 = require("zod");
exports.LiveActivityContentStateSchema = zod_1.z.object({
    schemaVersion: zod_1.z.string(),
    view: zod_1.z.enum([
        "PRE_DEPARTURE_SHIFT_VIEW",
        "LIVE_ETA_FOR_TRIP_SHIFT_VIEW",
        "POST_TRIP_ARRIVAL_SHIFT_VIEW",
    ]),
    worker: zod_1.z.object({
        id: zod_1.z.string(),
    }),
    workplace: zod_1.z.object({
        name: zod_1.z.string(),
        address: zod_1.z.object({
            formattedAddress: zod_1.z.string(),
            longitude: zod_1.z.string(),
            latitude: zod_1.z.string(),
        }),
        timezone: zod_1.z.string(),
    }),
    shift: zod_1.z.object({
        id: zod_1.z.string(),
        start: zod_1.z.string(),
        end: zod_1.z.string(),
    }),
    clipboardScore: zod_1.z.object({
        clockInOnTime: zod_1.z.number(),
        latenessPenalty: zod_1.z.number(),
    }),
    trip: zod_1.z.object({
        expectedArrivalTime: zod_1.z.string(),
        leaveByTime: zod_1.z.string().optional(),
        tripProgressPercentage: zod_1.z.number().optional(),
        lastEtaReceivedAt: zod_1.z.string().optional(),
        isLastReceivedEtaFresh: zod_1.z.boolean().optional(),
        preDepartureShiftViewTimingStatus: zod_1.z
            .enum(["early", "leaveSoon", "leaveNow", "late"])
            .optional(),
    }),
});
